import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Form from "react-bootstrap/Form";
import thumb1 from "../../../assets/images/video_thumbnails/1.png";
import ic_delete from "../../../assets/images/ic_delete.svg";
import ic_edit from "../../../assets/images/ic_edit.svg";
import ic_eyes from "../../../assets/images/ic_eyes.svg";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import { ToastMsg } from "../../TostMsg";
import {
  postWithAuthCallWithErrorResponse,
  putCallWithAuthTokenWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../../../api/ApiServices";
import ApiConfig, { IMAGE_URL } from "../../../api/ApiConfig";
import quraan_kareem_cover_9_line from "../../../assets/images/quraan_kareem_cover_9_line.png";
import ic_nursery_tr_1 from "../../../assets/images/ic_nursery_tr_1.png";
import panch_min_ka_madrasa from "../../../assets/images/panch_min_ka_madrasa.png";
import { sendAsFormData } from "../../commonFun";
import FormLoader from "../../FormLoader";
const MobileApps = () => {
  const { sidebar, adminData } = useContext(AppContext);

  const [AddNewGroup, setAddNewGroup] = useState(0);
  const [quraneKareemList, setQuraneKareemList] = useState([]);
  const [maktabList, setMaktabList] = useState([]);
  const [otherAppsList, setOtherAppsList] = useState([]);


  const [isImage, setIsImage] = useState("");
  const [imageWidth, setImageWidth] = useState("100%");

  const [isEdit, setIsEdit] = useState("");
  const [isEditMakTab, setIsEditMakTab] = useState("");
  const [isEditOtherApps, setIsEditOtherApps] = useState("");

  const [assistId, setAssistId] = useState(0);
  const [assistIdMaktab, setAssistIdMaktab] = useState(0);
  const [assistIdOther, setAssistIdOther] = useState(0);

  const [addMaktabApps, setAddMaktabApps] = useState(false);
  const handleAddMaktabAppsClose = () => setAddMaktabApps(false);
  const handleAddMaktabAppsShow = () => setAddMaktabApps(true);

  const [addOtherApps, setAddOtherApps] = useState(false);
  const handleAddOtherAppsClose = () => setAddOtherApps(false);
  const handleAddOtherAppsShow = () => setAddOtherApps(true);

  const [addFeature, setAddFeature] = useState(false);
  const handleAddFeatureClose = () => setAddFeature(false);
  const handleAddFeatureShow = () => setAddFeature(true);

  const [addQuraan, setAddQuraan] = useState(false);
  const handleAddQuraanClose = () => setAddQuraan(false);
  const handleAddQuraanShow = () => setAddQuraan(true);

  const [addWorksrhop, setAddWorksrhop] = useState(false);
  const handleAddWorksrhopClose = () => setAddWorksrhop(false);
  const handleAddWorksrhopShow = () => setAddWorksrhop(true);

  const [deleteModal, setDelete] = useState(false);
  const handleDeleteClose = () => setDelete(false);
  const handleDeleteShow = () => setDelete(true);

  const [MainVideo, setMainVideo] = useState(false);
  const handleMainVideoClose = () => setMainVideo(false);
  const handleMainVideoShow = () => setMainVideo(true);

  const [AddSteps, setAddSteps] = useState(false);
  const handleAddStepsClose = () => setAddSteps(false);
  const handleAddStepsShow = () => setAddSteps(true);

  const [validated, setValidated] = useState(false);
  const [loader, setLoader] = useState(false);
  const [vedioApiList, setvedioApiList] = useState([]);
  const [videoEditData, setVideoEditData] = useState({
    subcategory_media_VideoName_hindi: "",
    subcategory_media_VideoPath_hindi: "",
    subcategory_media_VideoDuaration_hindi: "",
    subcategory_media_VideoName_lit: " ",
    subcategory_media_VideoPath_lit: "",
    subcategory_media_VideoDuaration_lit: " ",
    subcategory_media_VideoName_urdu: "",
    subcategory_media_VideoPath_urdu: "",
    subcategory_media_VideoDuaration_urdu: "",
    subcategory_media_VideoName_english: " ",
    subcategory_media_VideoPath_english: "",
    subcategory_media_VideoDuaration_english: "",
    subcategory_id: 2,
  });

  // Qurane Kareem section Add Quran
  const [addQuraanObj, setAddQuraanObj] = useState({
    assist_second_heading_hindi: "",
    assist_second_heading_english: "",
    assist_second_heading_lit: "",
    assist_second_heading_urdu: "",

    assist_desc_urdu: "",
    assist_title_urdu: "",
    assist_title_lit: "",
    assist_desc_lit: "",
    assist_desc_english: "",
    assist_title_english: "",
    file: "",
    assist_option_id: 5,
    assist_desc_hindi: "",
    assist_title_hindi: "",
    link_two: "",
    link_one: "",
    option_assis_img: "",
    option_assist_main_id: 0,
  });

  // Mobile Apps Add Maktab Apps
  const [addMaktabAppObj, setAddMaktabAppObj] = useState({
    assist_second_heading_hindi: "",
    assist_second_heading_english: "",
    assist_second_heading_lit: "",
    assist_second_heading_urdu: "",

    assist_desc_urdu: "",
    assist_title_urdu: "",
    assist_title_lit: "",
    assist_desc_lit: "",
    assist_desc_english: "",
    assist_title_english: "",
    file: "",
    assist_option_id: 6,
    assist_desc_hindi: "",
    assist_title_hindi: "",
    link_two: "",
    link_one: "",
    option_assis_img: "",
    option_assist_main_id: 0,
  });

  // Add Other Apps
  const [addOtherAppObj, setAddOtherAppObj] = useState({
    assist_second_heading_hindi: "",
    assist_second_heading_english: "",
    assist_second_heading_lit: "",
    assist_second_heading_urdu: "",

    assist_desc_urdu: "",
    assist_title_urdu: "",
    assist_title_lit: "",
    assist_desc_lit: "",
    assist_desc_english: "",
    assist_title_english: "",
    file: "",
    assist_option_id: 7,
    assist_desc_hindi: "",
    assist_title_hindi: "",
    link_two: "",
    link_one: "",
    option_assis_img: "",
    option_assist_main_id: 0,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    const addQuraanDatacopy = { ...addQuraanObj };
    addQuraanDatacopy[name] = value;
    setAddQuraanObj(addQuraanDatacopy);

    const addMaktabDatacopy = { ...addMaktabAppObj };
    addMaktabDatacopy[name] = value;
    setAddMaktabAppObj(addMaktabDatacopy);

    const addOtherAppDatacopy = { ...addOtherAppObj };
    addOtherAppDatacopy[name] = value;
    setAddOtherAppObj(addOtherAppDatacopy);
  };

  const handleChangeVideoEdit = (event) => {
    const { name, value } = event.target;
    const videoEditDatacopy = { ...videoEditData };
    videoEditDatacopy[name] = value;
    setVideoEditData(videoEditDatacopy);
  };
  const handleSubmit = (event, section) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (section == "updateVideos") {
        updateMediaApi(event);
      }
      if (section == "quraan") {
        submitAddQuraan(event);
      }
      if (section == "maktab") {
        submitAddMaktab(event)
      }
      if (section == "otherApps") {
        submitAddOtherApps(event);
      }
    }

    setValidated(true);
  };
  useEffect(() => {
    videoApiList();
  }, []);
  const videoApiList = () => {
    setLoader(true);
    // ?subcategory_id=3&school_workshop_ten_step_id=10
    simpleGetCallWithErrorResponse(
      ApiConfig.GET_MEDIEA + `?subcategory_id=${9}`
    )
      .then((res) => {
        console.log(res);
        if (res.json && res.json?.result === true) {
          setLoader(false);

          setvedioApiList(res.json.media);
          setVideoEditData(res.json.editmedia);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        // setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  const updateMediaApi = (e) => {
    e.preventDefault();
    handleMainVideoClose();
    putCallWithAuthTokenWithErrorResponse(
      ApiConfig.UPDATE_MEDIEA + `?subcategory_id=${9}`,
      JSON.stringify({
        ...videoEditData,
        modified_by_id: adminData.user_id,
      })
    )
      .then((res) => {
        if (res.json && res.json?.result === true) {
          ToastMsg("success", res.json.message);
          videoApiList();
          // tenStepsListApi(addBtn);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  // Add Quraan Assist
  const submitAddQuraan = (e) => {
    e.preventDefault();
    handleAddQuraanClose(true);
    setLoader(true);

    !isEdit
      ? postWithAuthCallWithErrorResponse(
        ApiConfig.ADD_QURAAN_FORM,
        sendAsFormData(addQuraanObj)
      )
        .then((res) => {
          setLoader(false);
          if (res.json.result) {
            ToastMsg("success", "Successfully Added");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
            );
          } else {
            // ToastMsg("error", "Something Went Wrong")
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
      : postWithAuthCallWithErrorResponse(
        ApiConfig.UPDATE_ASSIST_DATA,
        sendAsFormData(addQuraanObj)
      )
        .then((res) => {
          setLoader(false);
          if (res.json.result) {
            ToastMsg("success", "Successfully Updated");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
            );
          } else {
            // ToastMsg("error", "Something Went Wrong")
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
  };

  // Add Maktab
  const submitAddMaktab = (e) => {
    e.preventDefault();
    handleAddMaktabAppsClose(true);
    setLoader(true);

    !isEditMakTab
      ? postWithAuthCallWithErrorResponse(
        ApiConfig.ADD_QURAAN_FORM,
        sendAsFormData(addMaktabAppObj)
      )
        .then((res) => {
          setLoader(false);
          if (res.json.result) {
            ToastMsg("success", "Successfully Added");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${6}`
            );
          } else {
            // ToastMsg("error", "Something Went Wrong")
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${6}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
      : postWithAuthCallWithErrorResponse(
        ApiConfig.UPDATE_ASSIST_DATA,
        sendAsFormData(addMaktabAppObj)
      )
        .then((res) => {
          setLoader(false);
          if (res.json.result) {
            ToastMsg("success", "Successfully Updated");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${6}`
            );
          } else {
            // ToastMsg("error", "Something Went Wrong")
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${6}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
  };

  // Add Other Apps
  const submitAddOtherApps = (e) => {
    e.preventDefault();
    handleAddOtherAppsClose(true);
    setLoader(true);
    !isEditOtherApps
      ? postWithAuthCallWithErrorResponse(
        ApiConfig.ADD_QURAAN_FORM,
        sendAsFormData(addOtherAppObj)
      )
        .then((res) => {
          setLoader(false);
          if (res.json.result) {
            ToastMsg("success", "Successfully Added");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${7}`
            );
          } else {
            // ToastMsg("error", "Something Went Wrong")
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${7}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
      : postWithAuthCallWithErrorResponse(
        ApiConfig.UPDATE_ASSIST_DATA,
        sendAsFormData(addOtherAppObj)
      )
        .then((res) => {
          setLoader(false);
          if (res.json.result) {
            ToastMsg("success", "Successfully Updated");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${7}`
            );
          } else {
            // ToastMsg("error", "Something Went Wrong")
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${7}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
  };

  // Qurane Kareem List
  const quranekareemListApi = (urldata) => {
    setLoader(true);
    simpleGetCallWithErrorResponse(urldata)
      .then((res) => {
        setLoader(false);
        setQuraneKareemList(res.json.data);
        setMaktabList(res.json.data);
        setOtherAppsList(res.json.data);
      })
      .catch((err) => {
        setLoader(false);
        ToastMsg("error", "something went wrong");
      });
  };

  useEffect(() => {
    quranekareemListApi(
      ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
    );
  }, []);

  // Get Update Data of Assist Qurane Kareem
  const getUpdateDataId = (id) => {
    simpleGetCallWithErrorResponse(
      ApiConfig.GET_EDIT_DATA + `?assist_main_id=${id}`
    )
      .then((res) => {
        console.log("res>>>>>", res)
        let data = res.json.assist;
        let assist_record = res.json.assist_data;

        setAddQuraanObj({
          assist_desc_urdu: data.assist_desc_urdu,
          assist_title_urdu: data.assist_title_urdu,
          assist_title_lit:data.assist_desc_lit,
          assist_desc_lit:  data.assist_title_lit,
          assist_desc_english: data.assist_desc_english,
          assist_title_english: data.assist_title_english,
          file: data.file,
          assist_option_id: 5,
          assist_desc_hindi: data.assist_desc_hindi,
          assist_title_hindi: data.assist_title_hindi,
          link_two: data.link_two,
          link_one: data.link_one,
          option_assis_img: "",
          option_assist_main_id: id,

          assist_second_heading_hindi: assist_record[0]?.assist_second_heading,
          assist_second_heading_english:
            assist_record[1]?.assist_second_heading,
          assist_second_heading_lit: assist_record[2]?.assist_second_heading,
          assist_second_heading_urdu: assist_record[3]?.assist_second_heading,
        });
      })
      .catch((err) => {
        console.log(err);
        // ToastMsg("error", "something went wrong");
      });
  };

  const deleteAssist = (id) => {
    setAssistId(id);
  };

  const deleteAssistMaktab = (id) => {
    setAssistIdMaktab(id);
  };

  const deleteAssistOther = (id) => {
    setAssistIdOther(id);
  };

  // Delete Assist
  const deleteAssistPopUp = () => {
    handleDeleteClose();
    setLoader(true);
    assistId
      ? simpleGetCallWithErrorResponse(
        ApiConfig.ASSIST_DELETE_ID + `?assist_main_id=${assistId}`
      )
        .then((res) => {
          setLoader(false);
          handleDeleteClose();
          ToastMsg("success", "Successfully Deleted");
          quranekareemListApi(
            ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
          );
          // setQuraneKareemList(res.json.data);
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
          quranekareemListApi(
            ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
          );
          // ToastMsg("error", "something went wrong");
        })
      : assistIdMaktab
        ? simpleGetCallWithErrorResponse(
          ApiConfig.ASSIST_DELETE_ID + `?assist_main_id=${assistIdMaktab}`
        )
          .then((res) => {
            setLoader(false);
            handleDeleteClose();
            ToastMsg("success", "Successfully Deleted");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${6}`
            );
            // setQuraneKareemList(res.json.data);
          })
          .catch((err) => {
            console.log(err);
            setLoader(false);
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${6}`
            );
            // ToastMsg("error", "something went wrong");
          })
        : simpleGetCallWithErrorResponse(
          ApiConfig.ASSIST_DELETE_ID + `?assist_main_id=${assistIdOther}`
        )
          .then((res) => {
            setLoader(false);
            handleDeleteClose();
            ToastMsg("success", "Successfully Deleted");
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${7}`
            );
            // setQuraneKareemList(res.json.data);
          })
          .catch((err) => {
            console.log(err);
            setLoader(false);
            quranekareemListApi(
              ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${7}`
            );
            // ToastMsg("error", "something went wrong");
          });
  };

  // Update Maktab
  const getUpdateMaktabData = (id) => {
    simpleGetCallWithErrorResponse(
      ApiConfig.GET_EDIT_DATA + `?assist_main_id=${id}`
    )
      .then((res) => {
        let data = res.json.assist;
        let assist_record = res.json.assist_data;

        setAddMaktabAppObj({
          assist_desc_urdu: data.assist_desc_english,
          assist_title_urdu: data.assist_title_urdu,
          assist_title_lit: data.assist_title_lit,
          assist_desc_lit: data.assist_desc_lit,
          assist_desc_english: data.assist_desc_english,
          assist_title_english: data.assist_title_english,
          file: data.file,
          assist_option_id: 6,
          assist_desc_hindi: data.assist_desc_hindi,
          assist_title_hindi: data.assist_title_hindi,
          link_two: data.link_two,
          link_one: data.link_one,
          option_assis_img: "",
          option_assist_main_id: id,

          assist_second_heading_hindi: assist_record[0]?.assist_second_heading,
          assist_second_heading_english:
            assist_record[1]?.assist_second_heading,
          assist_second_heading_lit: assist_record[2]?.assist_second_heading,
          assist_second_heading_urdu: assist_record[3]?.assist_second_heading,
        });
      })
      .catch((err) => {
        console.log(err);
        // ToastMsg("error", "something went wrong");
      });
  };

  // Update Other Apps
  const getUpdateOtherAppsData = (id) => {
    simpleGetCallWithErrorResponse(
      ApiConfig.GET_EDIT_DATA + `?assist_main_id=${id}`
    )
      .then((res) => {
        let data = res.json.assist;
        let assist_record = res.json.assist_data;

        setAddOtherAppObj({
          assist_desc_urdu: data.assist_desc_english,
          assist_title_urdu: data.assist_title_urdu,
          assist_title_lit: data.assist_title_lit,
          assist_desc_lit: data.assist_desc_lit,
          assist_desc_english: data.assist_desc_english,
          assist_title_english: data.assist_title_english,
          file: data.file,
          assist_option_id: 7,
          assist_desc_hindi: data.assist_desc_hindi,
          assist_title_hindi: data.assist_title_hindi,
          link_two: data.link_two,
          link_one: data.link_one,
          option_assis_img: "",
          option_assist_main_id: id,

          assist_second_heading_hindi: assist_record[0]?.assist_second_heading,
          assist_second_heading_english:
            assist_record[1]?.assist_second_heading,
          assist_second_heading_lit: assist_record[2]?.assist_second_heading,
          assist_second_heading_urdu: assist_record[3]?.assist_second_heading,
        });
      })
      .catch((err) => {
        console.log(err);
        // ToastMsg("error", "something went wrong");
      });
  };

  const handleAddQuraanShowClear = () => {
    setIsImage("");
    setAddQuraanObj({
      assist_second_heading_hindi: "",
      assist_second_heading_english: "",
      assist_second_heading_lit: "",
      assist_second_heading_urdu: "",

      assist_desc_urdu: "",
      assist_title_urdu: "",
      assist_title_lit: "",
      assist_desc_lit: "",
      assist_desc_english: "",
      assist_title_english: "",
      file: "",
      assist_option_id: 5,
      assist_desc_hindi: "",
      assist_title_hindi: "",
      link_two: "",
      link_one: "",
      option_assis_img: "",
      option_assist_main_id: 0,
    });
    setValidated(false)
  }

  const handleAddMaktabAppsShowClear = () => {
    setIsImage("");
    setAddMaktabAppObj({
      assist_second_heading_hindi: "",
      assist_second_heading_english: "",
      assist_second_heading_lit: "",
      assist_second_heading_urdu: "",

      assist_desc_urdu: "",
      assist_title_urdu: "",
      assist_title_lit: "",
      assist_desc_lit: "",
      assist_desc_english: "",
      assist_title_english: "",
      file: "",
      assist_option_id: 6,
      assist_desc_hindi: "",
      assist_title_hindi: "",
      link_two: "",
      link_one: "",
      option_assis_img: "",
      option_assist_main_id: 0,
    });
    setValidated(false)
  }

  const handleAddOtherAppsShowClear = () => {
    setIsImage("");
    setAddOtherAppObj({
      assist_second_heading_hindi: "",
      assist_second_heading_english: "",
      assist_second_heading_lit: "",
      assist_second_heading_urdu: "",

      assist_desc_urdu: "",
      assist_title_urdu: "",
      assist_title_lit: "",
      assist_desc_lit: "",
      assist_desc_english: "",
      assist_title_english: "",
      file: "",
      assist_option_id: 7,
      assist_desc_hindi: "",
      assist_title_hindi: "",
      link_two: "",
      link_one: "",
      option_assis_img: "",
      option_assist_main_id: 0,
    });
    setValidated(false);
  }
  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Mobile Apps</label>
        </div>
      </div>

      {/* ======================= DELETE ========================== */}

      <Modal
        show={deleteModal}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              onClick={deleteAssistPopUp}
              type="submit"
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      {/* ======================= END DELETE ========================== */}

      <div className="main-wrapper" id="maktab-main">
        <div className="main-all-video ">
          {vedioApiList?.length > 0 && (
            <div className="right">
              <div className="add-btn">
                <button onClick={handleMainVideoShow}>
                  <img src={ic_edit} alt="" />
                </button>
              </div>
            </div>
          )}

          {vedioApiList?.length > 0 ? (
            vedioApiList?.map((videolist, index) => {
              return (
                <div className="outer-main-video row" key={index}>
                  {videolist.sub_category_media.map((subitem, index) => {
                    return (
                      <div className="col-md-3 outer-main-video" key={index}>
                        <h6>
                          {(subitem.language_id === 4 && <span>Hindi</span>) ||
                            (subitem.language_id === 1 && (
                              <span>English</span>
                            )) ||
                            (subitem.language_id === 2 && <span>Urdu</span>) ||
                            (subitem.language_id === 3 && (
                              <span>Tansliteration </span>
                            ))}{" "}
                          Video
                        </h6>
                        <div className="video">
                          <a href={subitem.subcategory_media_VideoPath}
                            target="_blank"
                          >
                            <img src={thumb1} alt="" />
                            <div className="play-btn">
                              <button class="button">
                                <span class="arrow"></span>
                                Play
                              </button>
                            </div>
                          </a>
                          {/* <video controls poster={thumb1}>
                            <source
                              src={subitem.subcategory_media_VideoPath}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video> */}
                        </div>
                        <div className="content">
                          <div className="left">
                            <div className="step-name">
                              <label htmlFor="" className="key">
                                Name:
                              </label>
                              <label htmlFor="" className="value ms-2">
                                {subitem.subcategory_media_VideoName}
                              </label>
                            </div>
                            <div className="duration">
                              <label htmlFor="" className="key">
                                Duration:
                              </label>
                              <label htmlFor="" className="value ms-2">
                                {subitem.subcategory_media_VideoDuaration}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })
          ) : (
            <h5 className="text-center text-danger">No Data Found</h5>
          )}

          <Modal
            show={MainVideo}
            onHide={handleMainVideoClose}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Video</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
                noValidate
                validated={validated}
                // onSubmit={(e) => handleSubmit(e,"videos")}
                onSubmit={(e) => handleSubmit(e, "updateVideos")}
              >
                <div className="feature-wrapper">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label>English URL</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoPath_english"
                        value={
                          videoEditData.subcategory_media_VideoPath_english
                        }
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter English URL
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Hindi URL</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoPath_hindi"
                        value={videoEditData.subcategory_media_VideoPath_hindi}
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Hindi URL
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Urdu URL</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoPath_urdu"
                        value={videoEditData.subcategory_media_VideoPath_urdu}
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Urdu URL
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Transliteration URL</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoPath_lit"
                        value={videoEditData.subcategory_media_VideoPath_lit}
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Transliteration URL
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Name English</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoName_english"
                        value={
                          videoEditData.subcategory_media_VideoName_english
                        }
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Name English
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Name Hindi</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoName_hindi"
                        value={videoEditData.subcategory_media_VideoName_hindi}
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Name Hindi
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Name Urdu</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoName_urdu"
                        value={videoEditData.subcategory_media_VideoName_urdu}
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Name Transliteration</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoName_lit"
                        value={videoEditData.subcategory_media_VideoName_lit}
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Name Urdu
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Duration English</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoDuaration_english"
                        value={
                          videoEditData.subcategory_media_VideoDuaration_english
                        }
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Duration English
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Duration Hindi</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoDuaration_hindi"
                        value={
                          videoEditData.subcategory_media_VideoDuaration_hindi
                        }
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Duration Hindi
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Duration Urdu</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoDuaration_urdu"
                        value={
                          videoEditData.subcategory_media_VideoDuaration_urdu
                        }
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Duration Urdu
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label>Duration Transliteration</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="subcategory_media_VideoDuaration_lit"
                        value={
                          videoEditData.subcategory_media_VideoDuaration_lit
                        }
                        onChange={handleChangeVideoEdit}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Duration Transliteration
                      </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Group
                        controlId="formBasicPassword"
                      >
                        <Form.Label>English Video Thumbnail</Form.Label>
                        <Form.Control
                          type="file"
                          placeholder="Select Thumbnail for English Video"
                        />
                      </Form.Group>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Group
                        controlId="formBasicPassword"
                      >
                        <Form.Label>Hindi Video Thumbnail</Form.Label>
                        <Form.Control
                          type="file"
                          placeholder="Select Thumbnail for Hindi Video"
                        />
                      </Form.Group>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Group
                        controlId="formBasicPassword"
                      >
                        <Form.Label>Urdu Video Thumbnail</Form.Label>
                        <Form.Control
                          type="file"
                          placeholder="Select Thumbnail for Urdu Video"
                        />
                      </Form.Group>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Group
                        controlId="formBasicPassword"
                      >
                        <Form.Label>Transliteration Video Thumbnail</Form.Label>
                        <Form.Control
                          type="file"
                          placeholder="Select Thumbnail for Transliteration Video"
                        />
                      </Form.Group>
                    </div>
                    <div className="buttons-modal  text-center mt-2  ">
                      <button className="me-2 ">MEDIA UPDATE</button>
                    </div>
                  </div>
                </div>
              </Form>
            </Modal.Body>
            {/* <Modal.Footer className="justify-content-center">
           
            </Modal.Footer> */}
          </Modal>
        </div>
        <hr />
        <Tab.Container id="left-tabs-example" defaultActiveKey="1">
          <Nav variant="pills" className="flex-row">
            <Nav.Item>
              <Nav.Link
                eventKey="1"
                onClick={() => {
                  quranekareemListApi(
                    ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${5}`
                  );
                  // quranekareemList(ApiConfig.FEATURE_LIST + `?subcategory_id=${2}`)
                }}
              >
                Quraan-E-Kareem
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="2"
                onClick={() => {
                  quranekareemListApi(
                    ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${6}`
                  );
                }}
              >
                Maktab
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="3"
                onClick={() => {
                  quranekareemListApi(
                    ApiConfig.QURANE_KAREEM_LIST + `?assist_option_id=${7}`
                  );
                }}
              >
                Other Apps
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            {/*   ====== Feature ===== */}

            <Tab.Pane eventKey="1">
              <div className="feature-lists publication-tab-content row">
                <div className="add-btn">
                  <button onClick={() => {
                    handleAddQuraanShow();
                    setIsEdit(false);
                    handleAddQuraanShowClear();
                  }}>
                    Add Quraan Apps +
                  </button>
                </div>
                {loader ? (
                  <FormLoader />
                ) : (
                  <>
                    {quraneKareemList && quraneKareemList.length > 0 ? (
                      quraneKareemList.map((card, index) => {
                        return (
                          <div className="col-md-3">
                            <div className="books-card-main">
                              <div className="btns-top">
                                <button
                                  className="delete "
                                  onClick={() => {
                                    handleDeleteShow();
                                    deleteAssist(card?.option_assist_main_id);
                                  }}
                                >
                                  <img src={ic_delete} alt="" />
                                </button>
                                <button
                                  onClick={() => {
                                    setIsEdit(true);
                                    handleAddQuraanShow();
                                    getUpdateDataId(
                                      card?.option_assist_main_id
                                    );
                                    setIsImage("edit");
                                    setImageWidth("117px");
                                  }}
                                  className="edit"
                                >
                                  <img src={ic_edit} alt="" />
                                </button>
                              </div>

                              <div className="inner-wrapper">
                                <Link to="#" className="book-img">
                                  <img
                                    // src={quraan_kareem_cover_9_line}
                                    // src={`https://api.deeniyatplus.com:3010/api/public/assist/${card.option_assis_img}`}
                                    src={`${IMAGE_URL}${card.option_assis_img}`}
                                    alt=""
                                  />
                                </Link>
                                {card.item.map((cardData) => {
                                  return (
                                    <>
                                      <div className="name">
                                        {cardData.assist_title}
                                      </div>
                                      <div className="name">
                                        {cardData.assist_desc}
                                      </div>
                                      <div className="line">
                                        {cardData.assist_second_heading}
                                      </div>
                                      <hr />

                                    </>
                                  );
                                })}


                                <div className="line">
                                  Playstore : {card.link_one}
                                </div>
                                <div className="line">
                                  Appstore : {card.link_two}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        <h5 className="text-danger text-center">
                          No Data Found
                        </h5>
                      </>
                    )}
                  </>
                )}
              </div>

              <Modal
                show={addQuraan}
                onHide={handleAddQuraanClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>{isEdit ? "Updated Quraan" : "Add Quraan"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={(e) => handleSubmit(e, "quraan")}
                  >
                    <div className="feature-wrapper">
                      <div className="row">
                        {/* <div className="col-md-12 mb-4">
                          <Form.Label>Quraan Image</Form.Label>
                          <Form.Control
                            // value={addQuraanObj?.file}
                            required
                            type="file"
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                file: e.target.files[0],
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div> */}

                        {isImage ? (
                          <>
                            <div>
                              {" "}
                              <Form.Label>Quraan Image</Form.Label>
                            </div>
                            <div className="col-md-12 mb-4  d-flex">
                              <div
                                className={
                                  imageWidth === "100%"
                                    ? "col-md-12 "
                                    : "col-md-2 "
                                }
                              >
                                <Form.Control
                                  style={{ width: imageWidth }}
                                  type="file"
                                  name="file"
                                  accept="image/png, image/gif, image/jpeg"
                                  // value={addFeatureData.file}
                                  onChange={(e) => {
                                    setAddQuraanObj({
                                      ...addQuraanObj,
                                      file: e.target.files[0],
                                    });
                                    setImageWidth("100%");
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Quraan Image
                                </Form.Control.Feedback>
                              </div>

                              <div
                                className={
                                  imageWidth === "100%"
                                    ? "d-none"
                                    : "col-md-10 "
                                }
                              >
                                <Form.Control
                                  disabled={true}
                                  required
                                  type="text"
                                  name="file"
                                  value={addQuraanObj.file}
                                  onChange={handleChange}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Quraan Image
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-md-12 mb-4">
                            <Form.Label>Quraan Image</Form.Label>
                            <Form.Control
                              required
                              type="file"
                              name="file"
                              accept="image/x-png,image/gif,image/jpeg"
                              // value={addFeatureData?.file}
                              onChange={(e) => {
                                setAddQuraanObj({
                                  ...addQuraanObj,
                                  file: e.target.files[0],
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Quraan Image
                            </Form.Control.Feedback>
                          </div>
                        )}

                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Urdu</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_title_urdu}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_title_urdu: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Urdu
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Hindi</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_title_hindi}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_title_hindi: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Hindi
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title English</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_title_english}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_title_english: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title English
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Transliteration</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_title_lit}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_title_lit: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Transliteration
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-6 mb-4">
                          <Form.Label>Line Title Urdu</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_second_heading_urdu}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_second_heading_urdu: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Title Urdu
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Line Title Hindi</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_second_heading_hindi}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_second_heading_hindi: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Title Hindi
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Line Heading English</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_second_heading_english}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_second_heading_english: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Title English
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Line Title Transliteration</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_second_heading_lit}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_second_heading_lit: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Title Transliteration
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Urdu</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_desc_urdu}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_desc_urdu: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Urdu.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Hindi</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_desc_hindi}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_desc_hindi: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Hindi.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-4">
                          <Form.Label>Description English</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_desc_english}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_desc_english: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description English.
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Transliteration</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.assist_desc_lit}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                assist_desc_lit: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Transliteration.
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Playstore Link</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.link_one}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                link_one: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Heading App Link
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Appstore Link</Form.Label>
                          <Form.Control
                            value={addQuraanObj?.link_two}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddQuraanObj({
                                ...addQuraanObj,
                                link_two: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Heading App Link
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="buttons-main">
                        {/* <button className="cancel-btn">Cancel</button> */}

                        <button
                          className="submit-btn"
                        // onClick={submitAddQuraan}
                        >
                          {isEdit ? "Update" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal.Body>
              </Modal>
            </Tab.Pane>

            {/* ======= Steps ======= */}
            <Tab.Pane eventKey="2">
              <div className="feature-lists publication-tab-content row">
                <div className="add-btn">
                  <button
                    onClick={() => {
                      handleAddMaktabAppsShow();
                      setIsEditMakTab(false);
                      handleAddMaktabAppsShowClear();
                    }}
                  >
                    Add Maktab Apps +
                  </button>
                </div>
                {loader ? (
                  <FormLoader />
                ) : (
                  <>
                    {maktabList && maktabList.length > 0 ? (
                      maktabList.map((card, index) => {
                        return (
                          <div className="col-md-3">
                            <div className="books-card-main">
                              <div className="btns-top">
                                <button
                                  className="delete "
                                  onClick={() => {
                                    handleDeleteShow();
                                    deleteAssistMaktab(
                                      card?.option_assist_main_id
                                    );
                                  }}
                                >
                                  <img src={ic_delete} alt="" />
                                </button>
                                <button
                                  onClick={() => {
                                    handleAddMaktabAppsShow();
                                    setIsEditMakTab(true);
                                    getUpdateMaktabData(
                                      card?.option_assist_main_id
                                    );
                                    setIsImage("edit");
                                    setImageWidth("117px");
                                  }}
                                  className="edit"
                                >
                                  <img src={ic_edit} alt="" />
                                </button>
                              </div>
                              <div className="inner-wrapper">
                                <Link to="/MaktabApps" className="book-img">
                                  <img
                                    // src={ic_nursery_tr_1}
                                    // src={`https://api.deeniyatplus.com:3010/api/public/assist/${card.option_assis_img}`}
                                    src={`${IMAGE_URL}${card.option_assis_img}`}
                                    alt=""
                                  />
                                </Link>
                                {card.item.map((cardData) => {
                                  return (
                                    <>
                                      <div className="name">
                                        {cardData.assist_title}
                                      </div>
                                      <div className="line">
                                        {cardData.assist_desc}
                                      </div>
                                      <hr />{" "}
                                    </>
                                  );
                                })}

                                <div className="line">
                                  <span className="fw-bold">Playstore: </span>
                                  {card.link_one}
                                </div>
                                <div className="line">
                                  <span className="fw-bold">Appstore: </span>
                                  {card.link_two}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        <h5 className="text-danger text-center">
                          No Data Found
                        </h5>
                      </>
                    )}
                  </>
                )}
              </div>

              <Modal
                show={addMaktabApps}
                onHide={handleAddMaktabAppsClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>{isEditMakTab ? "Update Maktab App" : "Add Maktab App"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={(e) => handleSubmit(e, "maktab")}

                  >
                    <div className="feature-wrapper">
                      <div className="row">
                        {/* <div className="col-md-12 mb-4">
                          <Form.Label>Image</Form.Label>
                          <Form.Control
                            // value={addMaktabAppObj.file}
                            type="file"
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                file: e.target.files[0],
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div> */}

                        {isImage ? (
                          <>
                            <div>
                              {" "}
                              <Form.Label> Image</Form.Label>
                            </div>
                            <div className="col-md-12 mb-4  d-flex">
                              <div
                                className={
                                  imageWidth === "100%"
                                    ? "col-md-12 "
                                    : "col-md-2 "
                                }
                              >
                                <Form.Control
                                  style={{ width: imageWidth }}
                                  type="file"
                                  name="file"
                                  accept="image/png, image/gif, image/jpeg"
                                  // value={addFeatureData.file}
                                  onChange={(e) => {
                                    setAddMaktabAppObj({
                                      ...addMaktabAppObj,
                                      file: e.target.files[0],
                                    });
                                    setImageWidth("100%");
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter  Image
                                </Form.Control.Feedback>
                              </div>

                              <div
                                className={
                                  imageWidth === "100%"
                                    ? "d-none"
                                    : "col-md-10 "
                                }
                              >
                                <Form.Control
                                  disabled={true}
                                  required
                                  type="text"
                                  name="file"
                                  value={addMaktabAppObj.file}
                                  onChange={handleChange}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Image
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-md-12 mb-4">
                            <Form.Label> Image</Form.Label>
                            <Form.Control
                              required
                              type="file"
                              name="file"
                              accept="image/x-png,image/gif,image/jpeg"
                              // value={addFeatureData?.file}
                              onChange={(e) => {
                                setAddMaktabAppObj({
                                  ...addMaktabAppObj,
                                  file: e.target.files[0],
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter  Image
                            </Form.Control.Feedback>
                          </div>
                        )}

                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Urdu</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_title_urdu}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_title_urdu: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Urdu
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Hindi</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_title_hindi}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_title_hindi: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Hindi
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title English</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_title_english}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_title_english: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title English
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Transliteration</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_title_lit}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_title_lit: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Transliteration
                          </Form.Control.Feedback>
                        </div>

                        {/* <div className="col-md-6 mb-4">
                          <Form.Label>Line Heading Urdu</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_second_heading_urdu}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_second_heading_urdu: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Heading Urdu
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Line Heading Hindi</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_second_heading_hindi}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_second_heading_hindi: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Heading Hindi
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Line Heading English</Form.Label>
                          <Form.Control
                            value={
                              addMaktabAppObj?.assist_second_heading_english
                            }
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_second_heading_english: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Heading English
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Line Heading Transliteration</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_second_heading_lit}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_second_heading_lit: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Heading Transliteration
                          </Form.Control.Feedback>
                        </div> */}

                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Urdu</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_desc_urdu}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_desc_urdu: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Urdu.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Hindi</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_desc_hindi}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_desc_hindi: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Hindi.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-4">
                          <Form.Label>Description English</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_desc_english}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_desc_english: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description English.
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Transliteration</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.assist_desc_lit}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                assist_desc_lit: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Transliteration.
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Playstore Link</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.link_one}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                link_one: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter App Link
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Appstore Link</Form.Label>
                          <Form.Control
                            value={addMaktabAppObj?.link_two}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddMaktabAppObj({
                                ...addMaktabAppObj,
                                link_two: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter App Link
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="buttons-main">
                        {/* <button className="cancel-btn">Cancel</button> */}

                        <button
                          className="submit-btn"
                        // onClick={submitAddMaktab}
                        >
                          {isEditMakTab ? "Update" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal.Body>
              </Modal>
            </Tab.Pane>

            {/* ====== JD ======= */}
            <Tab.Pane eventKey="3">
              <div className="feature-lists publication-tab-content row">
                <div className="add-btn">
                  <button
                    onClick={() => {
                      handleAddOtherAppsShow();
                      setIsEditOtherApps(false);
                      handleAddOtherAppsShowClear()
                    }}
                  >
                    Add Other Apps +
                  </button>
                </div>

                {loader ? (
                  <FormLoader />
                ) : (
                  <>
                    {otherAppsList && otherAppsList.length ? (
                      otherAppsList.map((card, index) => {
                        return (
                          <div className="col-md-3">
                            <div className="books-card-main">
                              <div className="btns-top">
                                {/* <Link to="/OtherApps">
                              <button onClick={handleAddQuraanShow} className="view">
                                <img src={ic_eyes} alt="" />
                              </button>
                            </Link> */}
                                <button
                                  className="delete "
                                  onClick={() => {
                                    handleDeleteShow();
                                    deleteAssistOther(
                                      card?.option_assist_main_id
                                    );
                                  }}
                                >
                                  <img src={ic_delete} alt="" />
                                </button>
                                <button
                                  onClick={() => {
                                    handleAddOtherAppsShow();
                                    setIsEditOtherApps(true);
                                    getUpdateOtherAppsData(
                                      card?.option_assist_main_id
                                    );
                                    setIsImage("edit");
                                    setImageWidth("117px");
                                  }}
                                  className="edit"
                                >
                                  <img src={ic_edit} alt="" />
                                </button>
                              </div>
                              <div className="inner-wrapper">
                                <Link to="#" className="book-img">
                                  <img
                                    // src={panch_min_ka_madrasa}
                                    // src={`https://api.deeniyatplus.com:3010/api/public/assist/${card.option_assis_img}`}
                                    src={`${IMAGE_URL}${card.option_assis_img}`}
                                    alt=""
                                  />
                                </Link>
                                {card?.item.map((cardData) => {
                                  return (
                                    <>
                                      <div className="name">
                                        {cardData.assist_title}
                                      </div>
                                      <div className="line">
                                        {cardData.assist_desc}
                                      </div>
                                      <div>
                                        {cardData.assist_second_heading}
                                      </div>
                                      <hr />
                                    </>
                                  );
                                })}
                                <div className="line">
                                  Playstore : {card.link_one}
                                </div>
                                <div className="line">
                                  Appstore : {card.link_two}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        <h5 className="text-danger text-center">
                          No Data Found
                        </h5>
                      </>
                    )}
                  </>
                )}
              </div>

              <Modal
                show={addOtherApps}
                onHide={handleAddOtherAppsClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>{isEditOtherApps ? "Update Other App" : "Add Other App"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={(e) => handleSubmit(e, "otherApps")}
                  >
                    <div className="feature-wrapper">
                      <div className="row">
                        {/* <div className="col-md-12 mb-4">
                          <Form.Label>Image</Form.Label>
                          <Form.Control
                            // value={addQuraanObj.file}
                            type="file"
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                file: e.target.files[0],
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div> */}

                        {isImage ? (
                          <>
                            <div>
                              {" "}
                              <Form.Label> Image</Form.Label>
                            </div>
                            <div className="col-md-12 mb-4  d-flex">
                              <div
                                className={
                                  imageWidth === "100%"
                                    ? "col-md-12 "
                                    : "col-md-2 "
                                }
                              >
                                <Form.Control
                                  style={{ width: imageWidth }}
                                  type="file"
                                  name="file"
                                  accept="image/png, image/gif, image/jpeg"
                                  // value={addFeatureData.file}
                                  onChange={(e) => {
                                    setAddOtherAppObj({
                                      ...addOtherAppObj,
                                      file: e.target.files[0],
                                    });
                                    setImageWidth("100%");
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter  Image
                                </Form.Control.Feedback>
                              </div>

                              <div
                                className={
                                  imageWidth === "100%"
                                    ? "d-none"
                                    : "col-md-10 "
                                }
                              >
                                <Form.Control
                                  disabled={true}
                                  required
                                  type="text"
                                  name="file"
                                  value={addOtherAppObj.file}
                                  onChange={handleChange}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Image
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-md-12 mb-4">
                            <Form.Label> Image</Form.Label>
                            <Form.Control
                              required
                              type="file"
                              name="file"
                              accept="image/x-png,image/gif,image/jpeg"
                              // value={addFeatureData?.file}
                              onChange={(e) => {
                                setAddOtherAppObj({
                                  ...addOtherAppObj,
                                  file: e.target.files[0],
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter  Image
                            </Form.Control.Feedback>
                          </div>
                        )}

                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Urdu</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_title_urdu}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_title_urdu: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Urdu
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Hindi</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_title_hindi}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_title_hindi: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Hindi
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title English</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_title_english}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_title_english: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title English
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Title Transliteration</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_title_lit}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_title_lit: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Title Transliteration
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-6 mb-4">
                          <Form.Label>Sub Heading Urdu</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_second_heading_urdu}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_second_heading_urdu: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sub Heading Urdu
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Sub Heading Hindi</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_second_heading_hindi}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_second_heading_hindi: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sub Heading Hindi
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Sub Heading English</Form.Label>
                          <Form.Control
                            value={
                              addOtherAppObj?.assist_second_heading_english
                            }
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_second_heading_english: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sub Heading English
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-4">
                          <Form.Label>Sub Heading Transliteration</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_second_heading_lit}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_second_heading_lit: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Line Heading Transliteration
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Urdu</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_desc_urdu}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_desc_urdu: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Urdu.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Hindi</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_desc_hindi}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_desc_hindi: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Hindi.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-4">
                          <Form.Label>Description English</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_desc_english}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_desc_english: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description English.
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Description Transliteration</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.assist_desc_lit}
                            as="textarea"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                assist_desc_lit: e.target.value,
                              });
                            }}
                            rows={3}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Description Transliteration.
                          </Form.Control.Feedback>
                        </div>

                        <div className="col-md-12 mb-4">
                          <Form.Label>Playstore Link</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.link_one}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                link_one: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter App Link
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-12 mb-4">
                          <Form.Label>Appstore Link</Form.Label>
                          <Form.Control
                            value={addOtherAppObj?.link_two}
                            type="text"
                            required
                            onChange={(e) => {
                              setAddOtherAppObj({
                                ...addOtherAppObj,
                                link_two: e.target.value,
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter App Link
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="buttons-main">
                        {/* <button className="cancel-btn">Cancel</button> */}

                        <button
                          className="submit-btn"
                        // onClick={submitAddOtherApps}
                        >
                          {isEditOtherApps ? "Update" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal.Body>
              </Modal>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </main>
  );
};

export default MobileApps;
